import { createStyles, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { elevatedSurfaceBoxShadow } from '../../shared/style-settings'

export const useMainPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},

    menuWrapper: {
      position: 'fixed',
      top: 20,
      left: 0,
      right: 0,
      zIndex: 10,
      '& .MuiAppBar-root': {
        boxShadow: elevatedSurfaceBoxShadow,
      },
      [theme.breakpoints.down('sm')]: {
        top: 0,
        '& .MuiAppBar-root': {
          backgroundColor: `${theme.palette.primary.main} !important`,
          boxShadow: 'none',
        },
        '& .MuiToolbar-root': {
          color: theme.palette.primary.contrastText,
        },
        '& .MuiAppBar-root a': {
          color: `${theme.palette.primary.contrastText} !important`,
        },
        '& .MuiAppBar-root .MuiToolbar-root span': {
          color: `${theme.palette.primary.contrastText} !important`,
        },
        '& .MuiAppBar-root .MuiSvgIcon-root': {
          color: theme.palette.primary.contrastText,
        },
        '& .MuiAppBar-root svg': {
          fill: `${theme.palette.primary.contrastText} !important`,
        },
        '& .MuiAppBar-root .MuiCircularProgress-root': {
          color: `${theme.palette.primary.contrastText} !important`,
        },
      },
    },
  })
)
